/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';
import CollapsedPanel from '/client/src/components/panel/collapsedPanel';
import SortableList from '/client/src/components/sortableList/container';
import arrayMove from 'array-move';
import QItem from './qItem';
import { defaultQuestionObj } from './defaultQuestionObj';

type PropsType = {
  tickets: [],
  questions: null | [],
  isSetAddtionalInfo: boolean,
  handleControlEventQuestion: () => void,
  handleControlEventAdditionalInfo: () => void
};

class Questions extends React.Component<PropsType> {
  props: PropsType;

  constructor(props: PropsType) {
    super(props);

    this.state = {
      questions: _.size(props.questions) > 0
      ? props.questions?.sort((a, b): number => a.placement_index - b.placement_index)
      : []
    };
  }

  onSortEnd = ({ oldIndex, newIndex }: any) => {
    const { questions } = this.state;
    const questionsMoved = arrayMove(questions, oldIndex, newIndex);
    const sortedQuestions = _.map(questionsMoved, (q: {}, i: number): {} => {
      return { ...q, placement_index: i + 1 };
    });

    this.setState({
      questions: sortedQuestions
    });

    this.props.handleControlEventQuestion(sortedQuestions);
  };

  handleAddQuestion = () => {
    const { questions, tickets } = this.props;
    const newItems = [
      ...questions,
      {
        ...defaultQuestionObj,
        id: 0 - _.size(questions),
        name: `New Question ${_.size(questions) + 1}`,
        temp_id: -1000 - _.size(questions) - 1,
        placement_index: _.size(questions) + 1,
        is_required: false,
        isNew: true,
        applied_to_ticket_id: _.map(tickets, (i: {}): {} => i.id),
        applied_to_all_tickets: true
      }
    ];

    this.setState({
      questions: newItems
    }, () => {
      this.props.handleControlEventQuestion(_.compact(newItems));
    });
  };

  handleRemove = (index: number, id: string | number) => {
    const { questions } = this.state;

    let newItems = _.clone(questions);

    if (id) {
      newItems = _.filter(questions, (q: {}): {} => {
        if (_.toString(q.id) !== _.toString(id)) {
          return q;
        }
      });
    } else {
      delete newItems[index];
    }

    this.setState({
      questions: _.compact(newItems)
    }, () => {
      this.props.handleControlEventQuestion(_.compact(newItems));
    });
  };

  _handleControlEventQuestion = (questions) => {
    this.props.handleControlEventQuestion(questions);
    this.setState({ questions });
  }

  render(): React.Element<typeof React.Element> {
    const {
      isSetAddtionalInfo,
      tickets,
      handleControlEventAdditionalInfo
    } = this.props;
    const { questions } = this.state;

    return (
      <CollapsedPanel
        status={isSetAddtionalInfo}
        title='Collect registration questions'
        onChange={(status: boolean): any => handleControlEventAdditionalInfo(status)}
      >
        <SortableList
          isClone={false}
          items={questions}
          // eslint-disable-next-line
          onSortEnd={this.onSortEnd}
          useDragHandle
          useWindowAsScrollContainer
          disableAutoscroll
          // eslint-disable-next-line
          handleRemoveTicket={this.handleRemove}
          item={QItem}
          type='questions'
          tickets={tickets}
          questions={questions}
          // eslint-disable-next-line
          handleControlEventQuestion={this._handleControlEventQuestion}
        />

        <div className="row">
          <div className="col-md-12">
            <button
              className="btn btn-default btn-default-pink btn-lg btn-block btn-text-left"
              type="button"
              onClick={this.handleAddQuestion}
            >
              <i className="icon icon-plus-square" style={{ marginRight: '1rem' }} />
              <span>New Question</span>
            </button>
          </div>
        </div>
      </CollapsedPanel>
    );
  }
}

export default Questions;
